package com.essntl.uikit.components.utils

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.checkbox.EsCheckBoxColors
import com.essntl.uikit.components.checkbox.EsCheckBoxState
import com.essntl.uikit.components.checkbox.EsTriPrimaryCheckBox
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun RowScope.EsRowDefaultItem(
    text: String?,
    extraContent: @Composable() (ColumnScope.() -> Unit) = {},
    spacedContent: @Composable() (RowScope.() -> Unit) = {},
    isFirst: Boolean = false,
    showsCheckBox: Boolean = false,
    checkBoxState: EsCheckBoxState = EsCheckBoxState.Unchecked,
    checkBoxColors: EsCheckBoxColors? = null,
    onCheckboxClicked: () -> Unit = {},
    weight: Float = 1f,
    modifier: Modifier = Modifier,
) {
    EsRowItem(
        isFirst = isFirst,
        weight = weight,
    ) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = modifier
                .align(Alignment.CenterStart)
                .fillMaxWidth()
                .padding(end = 1.spacing),
        ) {
            Row {
                if (showsCheckBox) {
                    EsTriPrimaryCheckBox(
                        state = checkBoxState,
                        colors = checkBoxColors,
                        onClick = onCheckboxClicked,
                    )

                    Spacer(modifier = Modifier.width(1.spacing))
                }
                Column(
                    modifier = Modifier
                        .align(Alignment.CenterVertically),
                ) {
                    if (!text.isNullOrEmpty())
                        Text(
                            text = text,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            style = MaterialTheme.esTypography.p2Medium14,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                        )
                    extraContent()
                }
            }
            spacedContent()
        }
    }
}

@Composable
fun RowScope.EsRowItem(
    isFirst: Boolean = false,
    weight: Float = 1f,
    content: @Composable BoxScope.() -> Unit = {},
) {
    if (!isFirst) {
        Spacer(
            modifier = Modifier
                .padding(end = 1.5f.spacing)
                .width(1.dp)
                .fillMaxHeight()
                .background(Color.Transparent),
        )
    }

    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .weight(weight),
    ) {
        content()
    }
}